import { IconButton, InputAdornment } from "@mui/material";
import { useContext, useState } from "react";
import { RHFTextField } from "src/components/hook-form";
import Iconify from "src/components/Iconify";

import Context from "../context";

// ----------------------------------------------------------------------

type Props = {
	label: string;
	type: string;
	name: string;
	message?: string;
};

export const TextInputField = ({ type, label, name, message }: Props) => {
	const [showPassword, setShowPassword] = useState(false);

	const { entity } = useContext(Context);

	const renderPassword = () => {
		return {
			endAdornment: (
				<InputAdornment position='end'>
					<IconButton edge='end' onClick={() => setShowPassword(!showPassword)}>
						<Iconify icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"} />
					</IconButton>
				</InputAdornment>
			)
		};
	};

	return (
		<RHFTextField
			fullWidth
			name={name}
			label={label}
			disabled={entity?.maintenance}
			helperText={message}
			type={showPassword ? "text" : type}
			InputProps={type === "password" ? renderPassword() : undefined}
		/>
	);
};

export default TextInputField;
